import { api } from '@/services'

export const list = (params) => {
  return api.get('/admin/item/list', { params })
}

export const show = (id) => {
  return api.get(`/admin/item/show/${id}`)
}

export const update = (item) => {
  return api.put('/admin/item/update', item)
}

export const create = (item) => {
  return api.post('/admin/item/create', item)
}

export const remove = (id) => {
  return api.delete(`/admin/item/delete/${id}`)
}
